<template>
  <div v-if="hasSupplierAgent" id="supplier-agent-information">
        <div @click="isPopupActive = true" style="cursor: pointer !important;">
            <vs-chip transparent color="primary">
                <vs-avatar icon="recent_actors" />
                <span class="bold text-xs">Ver información de agente</span>
            </vs-chip>
        </div>

        <vs-popup :active.sync="isPopupActive" title="Información del agente">
            <div class="vx-row">
                <div class="vx-col w-full">
                <h6>Aquí se muestra la información del agente que generó la solicitud</h6>
                </div>

                <div class="vx-col w-full mt-5">
                    <vs-input
                        class="w-full"
                        label="Nombre"
                        name="name"
                        v-model.lazy="agent.name"
                        icon-pack="feather"
                        placeholder="Nombre del agente"
                        disabled
                    />
                </div>
                <div class="vx-col w-full mt-5">
                    <vs-input
                        class="w-full"
                        label="Teléfono"
                        name="phone"
                        v-model.lazy="agent.phone"
                        icon-pack="feather"
                        placeholder="Télefono"
                        disabled
                    />
                </div>
                <div class="vx-col w-full mt-5">
                    <vs-input
                        class="w-full"
                        label="Correo electónico"
                        name="email"
                        v-model.lazy="agent.email"
                        icon-pack="feather"
                        placeholder="Correo electónico"
                        disabled
                    />
                </div>
            </div>
        </vs-popup>
  </div>
</template>

<script>
export default {
    name: "supplier-agent-information",
    props: {
        projectId: { type: [String, Number], required: true }
    },
    data(){
        return {
            agent: {}
            , isPopupActive: false
        }
    },
    beforeMount() {
        this.getSupplierAgentInformation();
    },
    computed: {
        hasSupplierAgent(){
            return !(Object.keys(this.agent).length === 0 && this.agent.constructor === Object);
        }
    },
    methods: {
        async getSupplierAgentInformation(){
            try {
                let response = await axios.get(`/api/project/${this.projectId}/getSupplierAgent`);
                this.agent = response.data;
            } catch (e) {
            }
        },
    }
}
</script>

<style>

</style>